
import axios from "axios";
import { wrapBaseApi } from "./apiWrapper";
import ls from 'utils/secureStorage';
import configs from "config";

export const handleCancelPayment = async (transferId: string) => {
  const persistedURL = ls.get(configs.PERSIST_URL);
  if (!transferId) {
    window.location.replace(`/${persistedURL}`);
    return;
  }

  const accessKey = ls.get(configs.ACCESS_KEY);
  const _auth = ls.get(configs.AUTH_TOKEN_KEY);
  const auth = _auth ? JSON.parse(_auth) : undefined;

  let authTokenAndAccessKey = [];
  if (auth?.token) authTokenAndAccessKey.push(auth?.token);
  if (accessKey) authTokenAndAccessKey.push(accessKey);

  try {

    const response = await axios.patch(wrapBaseApi(`/wallet/widget/transfer/${transferId}/cancel`), {}, {
      headers: {
        Authorization: authTokenAndAccessKey.join("::,")
      },
    });

    if (response.data) {
      setTimeout(() => window.location.replace(`/${persistedURL}`), 6000);
      // window.location.replace(`/${persistedURL}`);
    }
  } catch (error) {
    console.log(error, 'ERR');
    window.location.replace(`/${persistedURL}`);
  }
};